// This file will be populated with the output from CloudFormation deployment
export const config = {
  apiUrl: "https://j4qm3x35y9.execute-api.us-west-2.amazonaws.com/dev/",
  // AWS Cognito configuration
  region: "us-west-2",
  userPoolId: "us-west-2_IgM3c0b5g",
  userPoolClientId: "5l41fikkpsmeu6f92i2kjaq5vf",
};
